<div class="row">
	<div class="col-6">
		<label for="">Search:</label>
		<input type="text" class="form-control" placeholder="Search"
			(keyup)="searchNgxDatatable($event,'lead_id,agent_name,alias,prospect_company,campaign_name,amount')" />
	</div>
	<div class="col-6">
		<label for="">Date Range:</label>
		<app-form-range-date style="width: 100%;" [(ngModel)]="dateRange_" (OnSelected)="dateSelected()"
			[position]="'rigth'" [range_type]="'RANGE_PAST'" [autoApply]="true"></app-form-range-date>
	</div>
</div>
<!-- <div class="form-group col-sm-4" style="padding-top: 30px">
	<button type="submit" class="btn btn-primary" (click)="getPayedLeads()"><i class="fa fa-search"></i>Search</button>
</div> -->

<app-column-selector [columns]="columns"></app-column-selector>
<div class="table-responsive">
	<table class="cc-table-paid">
		<thead>
			<tr>
				<th class="col-idx">#</th>
				<th *ngIf="showHideColumns('agent_name')">Agent</th>
				<th *ngIf="showHideColumns('alias')">Alias</th>
				<th *ngIf="showHideColumns('prospect_company')">Prospect</th>
				<th>Campaign</th>
				<th>Paid Date</th>
				<th>Amount</th>
				<th>Options</th>
			</tr>
		</thead>

		<tbody>
			<tr *ngIf="loading">
				<td [attr.colspan]="8" class="text-center py-4">
					<div class="spinner-border text-primary spinner-border-sm" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</td>
			</tr>

			<tr *ngFor="let row of pagedPayedLeads">
				<td class="col-idx">{{ row.lead_id }}</td>

				<td *ngIf="showHideColumns('agent_name')">{{ row.agent_name }}</td>
				<td *ngIf="showHideColumns('alias')">{{ row.alias }}</td>
				<td *ngIf="showHideColumns('prospect_company')">{{ row.prospect_company }}</td>

				<td [ngClass]="getCellClassCampaign({ row: row })">
					<span (click)="editCampaign(row['campaign_id'])">
						<i class="fa fa-check" aria-hidden="true" *ngIf="row['campaign_active'] == '1'" title="Active campaign"></i>
						<i class="fa fa-ban" aria-hidden="true" *ngIf="row['campaign_active'] != '1'" title="Inactive campaign"></i>
						{{ row["campaign_name"] }}
					</span>
				</td>

				<td>{{ row["date_charged"] | utcToLocal : "mediumDate" }}</td>

				<td>{{ row["amount"] | currency : "USD" }}</td>

				<td [ngClass]="getCellClassOptions({ row: row })">
					<button class="btn btn-danger waves-effect waves-light btn-sm" (click)="undoPayment(row)">Undo payment</button>
				</td>
			</tr>

			<tr *ngIf="!loading && payed_leads.length === 0">
				<td [attr.colspan]="8" class="text-center py-4 text-muted">No records found.</td>
			</tr>
		</tbody>

		<tfoot>
			<tr>
				<td [attr.colspan]="8">
					<div class="row">
						<div class="col-3 centradoVertical">
							<strong class="footer-totals">Total Records: {{ payed_leads.length }}</strong>
						</div>
						<div class="col-3 centradoVertical">
							<strong class="footer-totals">Total Cost: {{ sumLeadCost | currency: 'USD' }}</strong>
						</div>
						<div class="col-6" align="right">
							<nav *ngIf="totalPages > 1">
								<ul class="cc-pager">
									<li>
										<button type="button" (click)="prevPage()" [disabled]="curPage === 1">
											<i class="ri-arrow-left-s-line"></i>
										</button>
									</li>
									<li *ngFor="let page of pageNumbers">
										<button type="button" [class.active]="page === curPage" (click)="goToPage(page)">
											{{ page }}
										</button>
									</li>
									<li>
										<button type="button" (click)="nextPage()" [disabled]="curPage === totalPages">
											<i class="ri-arrow-right-s-line"></i>
										</button>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</td>
			</tr>
		</tfoot>
	</table>
</div>
